import { render, staticRenderFns } from "./TaxiTable.component.vue?vue&type=template&id=4f79402c"
import script from "./TaxiTable.component.vue?vue&type=script&lang=ts"
export * from "./TaxiTable.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports